import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { NumericInput, Intent } from "@blueprintjs/core";

IntegerField.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Field value
   */
  value: PropTypes.number,

  /**
   * Triggered when field value is changed
   */
  onValueChange: PropTypes.func,

  /**
   * Triggered when field validity is changed
   */
  onValidityChange: PropTypes.func,

  /**
   * Set as required. If field is set as required an value is NULL then field will be marked as invalid
   */
  required: PropTypes.bool,

  /**
   * Min field value
   */
  minValue: PropTypes.number,

  /**
   * Max field value
   */
  maxValue: PropTypes.number,

  /**
   * Set to true to disable this field
   */
  disabled: PropTypes.bool
} : {};

function IntegerField(props) {
  var value = props.value,
      onValueChange = props.onValueChange,
      onValidityChange = props.onValidityChange,
      required = props.required,
      minValue = props.minValue,
      maxValue = props.maxValue,
      disabled = props.disabled,
      readOnly = props.readOnly,
      displayForm = props.displayForm;

  var _useState = useState(true),
      valid = _useState[0],
      setValid = _useState[1];

  var isInt = function isInt(n) {
    return typeof value === "number" && Number(n) === n && n % 1 === 0;
  };

  useEffect(function () {
    var invalidValue = value && !isInt(value);
    var invalidkMinValue = value && minValue && value < minValue;
    var invalidMaxValue = value && maxValue && value > maxValue;
    var isValid = !(invalidValue || invalidkMinValue || invalidMaxValue);
    if (isValid != valid) {
      setValid(isValid);
      onValidityChange && onValidityChange(isValid);
    }
  }, [value, valid, required, minValue, maxValue]);

  var handleChange = function handleChange(valueAsNumber, valueAsString) {
    onValueChange(!valueAsString || !valueAsNumber ? valueAsString : valueAsNumber);
  };

  return displayForm ? React.createElement(
    "span",
    { className: "dt-field-value" },
    value
  ) : React.createElement(NumericInput, {
    className: "bp3-intent-success",
    onValueChange: handleChange,
    value: value === null ? "" : value,
    buttonPosition: "none",
    disabled: disabled,
    readOnly: readOnly,
    intent: valid ? Intent.NONE : Intent.DANGER,
    fill: true
  });
}

export default IntegerField;